<template>
  <v-container fluid class="fabill-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Asset Bill</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Items</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Asset Bill</p>
                        <v-select
                          class="mb-4"
                          :items=assettype
                          v-model="new_fabill.assettype"
                          v-bind:error="error == 'assettype'"
                          v-on:change="clearFields(); clearTransactions()"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the asset type">
                        </v-select>
                        <v-menu
                          ref="menu_assetdate"
                          v-model="menu_assetdate"
                          :close-on-content-click="false"
                          :return-value.sync="new_fabill.assetdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-2"
                              outlined
                              dense
                              v-model="new_fabill.assetdate"
                              label="Purchase Date"
                              v-bind="attrs"
                              v-bind:value="new_fabill.assetdate"
                              v-bind:error="error == 'assetdate'"
                              v-on="on"
                              single-line hint="Enter asset purchase date"
                              persistent-hint
                              >
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_fabill.assetdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_assetdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_assetdate.save(new_fabill.assetdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_assetstartdate"
                          v-model="menu_assetstartdate"
                          :close-on-content-click="false"
                          :return-value.sync="new_fabill.assetstartdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="new_fabill.assetstartdate"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:value="new_fabill.assetstartdate"
                              v-bind:error="error == 'assetstartdate'"
                              v-on="on"
                              single-line hint="Enter asset start date"
                              persistent-hint
                              >
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_fabill.assetstartdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_assetstartdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_assetstartdate.save(new_fabill.assetstartdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>

                        <v-text-field
                          class="mb-4"
                          placeholder="Vendor Name"
                          single-line hint="Select the Vendor"
                          outlined
                          dense
                          readonly
                          v-model="new_fabill.vendorname"
                          v-bind:error="error == 'vendorid'"
                          append-icon="mdi-magnify"
                          @click:append="searchVendorDialog"
                          persistent-hint
                        >
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_fabill.assetname"
                          v-bind:error="error == 'assetname'"
                          outlined
                          dense
                          placeholder="Asset Name"
                          persistent-hint
                          single-line hint="Enter the asset name">
                        </v-text-field>      
                        <v-text-field
                          class="mb-4"
                          v-model="new_fabill.refnum"
                          outlined
                          dense
                          placeholder="Ref Num"
                          persistent-hint
                          single-line hint="Enter invoice or ref num">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="locations.map(x => { return {text: x.locationname, value: x._id} })"
                          v-model="new_fabill.locationid"
                          v-bind:error="error == 'locationid'"
                          outlined
                          dense
                          placeholder="Location"
                          persistent-hint
                          single-line hint="Please choose the location">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="departments.map(x => { return {text: x.departmentname, value: x._id} })"
                          v-model="new_fabill.departmentid"
                          v-bind:error="error == 'departmentid'"
                          outlined
                          dense
                          placeholder="Department"
                          persistent-hint
                          single-line hint="Please choose the deparment">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="[{text: 'None', value: null}, ...saleschannels.map(x => {return {text: x.channelname, value: x._id};})]"
                          v-model="new_fabill.channelid"
                          v-bind:error="error == 'channelid'"
                          outlined
                          dense
                          placeholder="Channel"
                          persistent-hint
                          single-line hint="Please choose the channel">
                        </v-select>

                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-select
                              class="mb-2"
                              :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                              v-model="new_fabill.primaryCurrency"
                              v-bind:error="error == 'primaryCurrency'"
                              outlined
                              dense
                              placeholder="Primary Currency"
                              persistent-hint
                              single-line hint="Currency 1">
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-select
                              class="mb-2"
                              :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                              v-model="new_fabill.secondaryCurrency"
                              v-bind:error="error == 'secondaryCurrency'"
                              v-bind:value="primaryCurrency"
                              outlined
                              dense
                              placeholder="Secondary Currency"
                              persistent-hint
                              single-line hint="Currency 2">
                            </v-select>
                          </v-col>
                        </v-row>
                        <v-text-field
                          class="mb-4"
                          v-model="new_fabill.currencyRate"
                          v-bind:error="error == 'currencyRate'"
                          :v-bind:value="1"
                          outlined
                          dense
                          placeholder="Rate"
                          persistent-hint
                          single-line hint="Rate">
                        </v-text-field>
                        <v-textarea
                          dense
                          v-model="new_fabill.fabillnote"
                          outlined
                          rows=1
                          label="Note"
                          hint="please enter the note"
                        ></v-textarea>
                      </v-form>
                    </v-col>                                        
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/fabill/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkFABill">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row>
                    <v-col md="10">
                      <p class="text-h5">Items</p>
                    </v-col>
                    <v-col md="2" align="right">
                      <v-btn
                        class="button-shadow"
                        color="success"
                        @click="isAddTransaction=true">
                        Add
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <v-data-table
                          :headers="header_item"
                          :items="transactions"
                          :items-per-page="500"
                          :footer-props="footer"
                          class="elevation-0"
                        >
                          <template v-slot:item.accountid="{ item }">
                            <p class="two-line">{{ accounts.length>0 ? accounts.find(asset=>asset._id == item.accountid)['accountname'] : '' }}</p>
                          </template>
                          <template v-slot:item.deptype="{ item }">
                            <p class="two-line">{{ item.deptype }}</p>
                          </template>
                          <template v-slot:item.deprate="{ item }">
                            <p class="two-line">Rate: {{ item.deprate!=null ? parseFloat(item.deprate).toFixed(2) : '' }}</p>
                            <p class="two-line">Value: {{ item.depvalue!=null ? parseFloat(item.depvalue).toFixed(2) : '' }}</p>
                          </template>
                          <template v-slot:item.itemamount="{ item }">
                            <p class="two-line">{{ item.itemamount!=null ? parseFloat(item.itemamount).toFixed(2) : '' }}</p>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-btn icon color="primary" @click="editTransactionDialog(item)">
                              <v-icon>mdi-pencil-outline</v-icon>
                            </v-btn>
                            <v-btn icon color="primary" @click="deleteTransaction(item)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                          outlined
                          color="primary"
                          @click="step = 1"
                        >
                          Back
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          v-if="1==0"
                          class="button-shadow"
                          color="primary"
                          @click="step = 3">
                          Next
                        </v-btn>
                        <v-btn
                          v-else
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="insertFABill()">
                          Save
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isSearchVendor"
        persistent
        scrollable
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <v-container>
              <v-row>
                <span class="text-h5" style="padding:10px">Search Vendor</span>
              </v-row>

            <v-row>
              <v-col cols="12" md="4">
                <v-form>
                  <v-text-field
                    class="mb-4"
                    v-model="searchvendor.searchtext"
                    outlined
                    dense
                    append-icon="mdi-magnify"
                    @click:append="searchVendor"
                    v-on:keyup.enter="searchVendor"
                    placeholder="Search"
                    persistent-hint
                    single-line hint="Search vendor"
                  >
                  </v-text-field>
                </v-form>
              </v-col>
            </v-row>
            </v-container>

          </v-card-title>
          <v-card-text style="height: 400px;">
            <v-container>
              <v-row>

                <v-col cols="12" md="12">
                  <v-data-table
                    :items-per-page="100"
                    :headers="header_vendor"
                    :items="searches"
                    item-value="name"
                  >
                  <template v-slot:item.vendorimage="{ item }">
                    <img v-if="item.vendorimage" v-bind:src="item.vendorimage" alt="" width="80">
                  </template>
                  <template v-slot:item.vendorname="{ item }">
                    <a class="primaryConst--text">{{ item.vendorname }}</a>
                    <p>{{ item.vendortype }}</p>
                  </template>
                  <template v-slot:item.vendoraddress="{ item }">
                    <a class="primaryConst--text">{{ item.vendoraddress }}</a>
                    <p class="two-line">{{ item.vendorphone  }}</p>
                    <p class="two-line">{{ item.vendormobile  }}</p>
                  </template>
                  <template v-slot:item.townshipid="{ item }">
                    <p class="two-line">{{ item.countryid!=undefined && countries.find(country=>country._id == item.countryid)!=null ? countries.find(country=>country._id == item.countryid)['countryname'] : ''   }}</p>
                    <p class="two-line">{{ item.townshipid!=undefined && townships.find(township=>township._id == item.townshipid)!=null ? townships.find(township=>township._id == item.townshipid)['townshipname'] : ''  }}</p>
                  </template>
                  <template v-slot:item.vendorstatus="{ item }">
                    <v-chip
                      :color="!item.vendorstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                      small>
                      {{ item.vendorstatus }}
                    </v-chip>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <div v-if="item._id!=undefined">
                    <v-btn icon color="primary" @click="selectVendor(item)">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    </div>
                  </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isSearchVendor = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isAddTransaction"
        persistent
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="5">
                  <v-select
                    class="mb-4"
                    :items="data_accounts"
                    v-model="new_transaction.accountid"
                    v-bind:error="error == 'accountid'"
                    outlined
                    dense
                    placeholder="Asset Class"
                    persistent-hint
                    single-line hint="Asset Class">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="new_transaction.itemdesc"
                    v-bind:error="error == 'itemdesc'"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Description"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    type="number"
                    v-model="new_transaction.itemamount"
                    v-bind:error="error == 'itemamount'"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amount"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    class="mb-4"
                    :items="['Rate', 'Value']"
                    v-model="new_transaction.deptype"
                    v-bind:error="error == 'deptype'"
                    outlined
                    dense
                    placeholder="Type"
                    persistent-hint
                    single-line hint="Depreciation Type">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="new_transaction.deprate"
                    v-bind:error="error == 'deprate'"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Rate"
                    persistent-hint
                    single-line hint="Depreciation Rate">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="new_transaction.depvalue"
                    v-bind:error="error == 'depvalue'"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Value"
                    persistent-hint
                    single-line hint="Depreciation Value">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; add_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="addTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="5">
                  <v-select
                    class="mb-4"
                    :items="data_accounts"
                    v-model="edit_transaction.accountid"
                    outlined
                    dense
                    placeholder="Asset "
                    persistent-hint
                    single-line hint="Asset ">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="edit_transaction.itemdesc"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Description"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.itemamount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amount"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-select
                    class="mb-4"
                    :items="['Rate', 'Value']"
                    v-model="edit_transaction.deptype"
                    outlined
                    dense
                    placeholder="Type"
                    persistent-hint
                    single-line hint="Depreciation Type">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.deprate"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Rate"
                    persistent-hint
                    single-line hint="Depreciation Rate">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.depvalue"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Value"
                    persistent-hint
                    single-line hint="Depreciation Value">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import { sortDataAsc } from '../../../util/tools';
import router from '@/Routes';

export default {
  data () {
    return {
      header_item: [
        { text: 'Account ', value: 'accountid', width: '20%'},
        { text: 'Description', value: 'itemdesc'},
        { text: 'Depreciation', value: 'deptype', width: '10%'},
        { text: 'Rate|Value', value: 'deprate', width: '15%'},
        { text: 'Amount', value: 'itemamount', width: '10%'},
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      header_vendor: [
        { text: 'Image', value: 'vendorimage', sortable: false },
        { text: 'Name', value: 'vendorname' },
        { text: 'Address', value: 'vendoraddress' },
        { text: 'Location', value: 'townshipid' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      classes: ['Cost of Good Sold', 'Administrative Expense', 'Operating Expense', 'Marketing Expense', 'Tax & Financing Expense', 'Factory & Production Expense', 'Debt & Loan', 'Overhead'],
      assettype: ['Current Asset', 'Fixed Asset', 'Intangible Asset'],
      accountsubclass: null,
      isSearchVendor: false,
      step: 1,
      new_fabill: {},
      new_transaction: {},
      edit_transaction: {},
      transactions: [],
      searches: [],

      searchvendor: {},
      isAddTransaction: false,
      isEditTransaction: false,
      menu_assetdate: false,
      menu_assetstartdate: false,
      menu_transdate: false,
      menu_transdate_edit: false,

      error: undefined,
      haserror: false,
      errorindex: undefined,
      isDualCurrency: false,
      primaryCurrency: null,
      secondaryCurrency: null,
      currencyRate: null,
      isTaxable: false,
      taxRate: null,
    }
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('FABill', ['fabills', 'isReceiving']),
    ...mapState('Country', ['countries']),
    ...mapState('Department', ['departments']),
    ...mapState('Location', ['locations']),
    ...mapState('SalesChannel', ['saleschannels']),
    ...mapState('SystemSetting', ['settings']),
    ...mapState('Township', ['townships']),
    ...mapState('User', ['users']),
    ...mapState('Vendor', ['vendors']),
    data_accounts(){
      let filter = this.accounts.filter(account=>(account.accountclass=='Asset') && account.options!=null && account.options.isFixedAsset==true).map(x => {return {text: x.accountname, value: x._id}});
      return filter;
    },
  },
  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('FABill', ['getFABillsRequest', 'insertFABillRequest']),
    ...mapActions('Department', ['getDepartmentsRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('SalesChannel', ['getSalesChannelsRequest']),
    ...mapActions('Search', ['searchVendorRequest']),
    ...mapActions('SystemSetting', ["getSetting", "getSystemSettingsRequest"]),
    ...mapActions('User', ['getUsersRequest']),
    ...mapActions('Vendor', ['getVendorsRequest']),
    checkFABill(){
      if(!this.new_fabill.assettype){
        this.error = 'assettype';
        return false;
      }
      if(!this.new_fabill.assetdate){
        this.error = 'assetdate';
        return false;
      }
      if(!this.new_fabill.assetstartdate){
        this.error = 'assetstartdate';
        return false;
      }
      if(!this.new_fabill.vendorid){
        this.error = 'vendorid';
        return false;
      }
      if(!this.new_fabill.assetname){
        this.error = 'assetname';
        return false;
      }
      if(!this.new_fabill.locationid){
        this.error = 'locationid';
        return false;
      }
      if(!this.new_fabill.departmentid){
        this.error = 'departmentid';
        return false;
      }
      if(!this.new_fabill.channelid){
        this.error = 'channelid';
        return false;
      }
      this.error = null;
      this.step = 2;
      return true;
    },
    checkTransaction(){
      if(!this.new_transaction.accountid){
        this.error = 'accountid';
        return false;
      }
      if(!this.new_transaction.itemdesc){
        this.error = 'itemdesc';
        return false;
      }
      if(!this.new_transaction.itemamount){
        this.error = 'itemamount'
        return false;
      }
      if(!this.new_transaction.deptype){
        this.error = 'deptype'
        return false;
      }
      if(!this.new_transaction.deprate){
        this.error = 'deprate'
        return false;
      }
      if(!this.new_transaction.depvalue){
        this.error = 'depvalue'
        return false;
      }
      this.error = null;
      return true;
    },
    addTransaction(){
      if(!this.checkTransaction()) return;
      let asset = this.accounts.find(asset=>asset._id==this.new_transaction.accountid);
      let dep = {deptype: asset.deptype, depyears: asset.depyears, deprate: asset.deprate};
      let trans = Object.assign(dep, this.new_transaction, {id: Math.floor(Math.random() * Math.pow(10, 10))});
      this.transactions.push(trans);
      this.isAddTransaction = false;
      this.clearFields();
    },
    clearFields(){
      this.new_transaction = {};
    },
    clearTransactions(){
      this.transactions = [];
    },
    async insertFABill() {
      if(this.transactions==null || this.transactions.length==0) return;
      let payload = {data: this.new_fabill, transactions: this.transactions};
      await this.insertFABillRequest(payload);
      router.push('/fabill/list');
    },
    deleteTransaction(item){
      let index = this.transactions.findIndex((trans) => trans.id == item.id);      
      if(index!=-1) this.transactions.splice(index,1);
    },
    insertTransaction(){
      let trans = Object.assign({}, this.transactions_expense, {id: Math.floor(Math.random() * Math.pow(10, 10)),});
      this.transactions.push(trans);
    },
    editTransactionDialog(item){
      this.edit_transaction = Object.assign({}, item);
      this.isEditTransaction = true;
    },
    editTransaction(){
      this.isEditTransaction = false;
      let index = this.transactions.findIndex((trans) => trans.id == this.edit_transaction.id);
      let trans = Object.assign({}, this.edit_transaction);
      this.transactions.splice(index, 1, trans);
      this.edit_transaction = {};
    },
    searchVendorDialog(){
      this.searchvendor = {};
      this.isSearchVendor = true;
    },
    selectVendor(item){
      this.new_fabill.vendorname = item.vendorname;
      this.new_fabill.vendoraddress = item.vendoraddress;
      this.new_fabill.vendorphone = item.vendorphone;
      this.new_fabill.vendormobile = item.vendormobile;
      this.new_fabill.vendorid = item._id;
      this.isSearchVendor = false;
    },
    async searchVendor(){
      let results = await this.searchVendorRequest(this.searchvendor);
      this.searches = results;
    }
  },

  async created () {
    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.departments.length==0) await this.getDepartmentsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
    if(this.users.length==0) await this.getUsersRequest();
    if(this.vendors.length==0) await this.getVendorsRequest();
    sortDataAsc(this.departments, 'departmentname');

    let currency = await this.getSetting({code: 'CurrencySettings', name: 'PrimaryCurrency'}, );
    let isTaxable = await this.getSetting({code: 'TaxSettings', name: 'isTaxEnabled'}, );
    this.new_fabill = Object.assign({}, {primaryCurrency: currency, secondaryCurrency: currency, currencyRate: 1, isTaxable: isTaxable});
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
